import { useNavigate } from 'react-router-dom';
import type { Property } from '@/types/api';

interface PropertyCardProps {
  property: Property;
}

export function PropertyCard({ property }: PropertyCardProps) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(`/properties/${property.id}`)}
      className="w-full text-left bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-6 hover:shadow-md hover:border-gray-300 dark:hover:border-gray-600 transition-all cursor-pointer"
    >
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{property.name}</h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{property.address}</p>

      {/* Four-stat footer — buildings + units are useful here on the list
          page (they help the user pick the right property at a glance);
          the property portal's stat strip carries meters / gateways /
          alarms only. */}
      <div className="grid grid-cols-4 gap-4 mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">
        <div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Buildings</p>
          <p className="text-xl font-bold text-gray-900 dark:text-gray-100 mt-0.5 tabular-nums">
            {property.buildingCount ?? 0}
          </p>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Units</p>
          <p className="text-xl font-bold text-gray-900 dark:text-gray-100 mt-0.5 tabular-nums">
            {property.unitCount ?? 0}
          </p>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Meters</p>
          <p className="text-xl font-bold text-gray-900 dark:text-gray-100 mt-0.5 tabular-nums">
            {property.deviceCount ?? 0}
          </p>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Alarms</p>
          <p className="text-xl font-bold text-primary-600 mt-0.5 tabular-nums">
            {property.activeAlarmCount ?? 0}
          </p>
        </div>
      </div>
    </button>
  );
}
